import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/works", label: "Selected Works" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Nav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const goHome = useCallback(() => {
    navigate("/");
    setMobileOpen(false);
  }, [navigate]);

  return (
    <>
      <header
        className={`fixed top-0 z-50 w-full transition-all duration-500 ${
          scrolled ? "bg-white/95 backdrop-blur-sm" : "bg-transparent"
        }`}
      >
        <div className="max-w-[900px] mx-auto px-6 sm:px-8 h-[60px] flex items-center justify-between">
          <button
            onClick={goHome}
            className="font-sans text-[13px] font-semibold tracking-[0.08em] uppercase text-[var(--text)] leading-none"
          >
            Murat Gulcelik
          </button>

          <nav className="hidden sm:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`font-sans text-[12px] tracking-[0.02em] transition-colors duration-200 ${
                  location.pathname === item.to
                    ? "text-[var(--text)]"
                    : "text-[var(--muted)] hover:text-[var(--text)]"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <button
            type="button"
            onClick={() => setMobileOpen(!mobileOpen)}
            className="sm:hidden flex flex-col gap-[5px] p-2 -mr-2"
            aria-label="Toggle menu"
          >
            <span
              className={`block w-[20px] h-[1px] transition-all duration-300 origin-center bg-[var(--text)] ${
                mobileOpen ? "rotate-45 translate-y-[6px]" : ""
              }`}
            />
            <span
              className={`block w-[20px] h-[1px] transition-all duration-300 bg-[var(--text)] ${
                mobileOpen ? "opacity-0" : ""
              }`}
            />
            <span
              className={`block w-[20px] h-[1px] transition-all duration-300 origin-center bg-[var(--text)] ${
                mobileOpen ? "-rotate-45 -translate-y-[6px]" : ""
              }`}
            />
          </button>
        </div>
      </header>

      <div
        className={`fixed inset-0 z-40 transition-all duration-300 sm:hidden ${
          mobileOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        } bg-white`}
      >
        <div className="flex h-full flex-col justify-center items-center px-8">
          <nav className="flex flex-col items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`font-sans text-[24px] font-light tracking-[0.02em] transition-colors ${
                  location.pathname === item.to
                    ? "text-[var(--text)]"
                    : "text-[var(--muted)] hover:text-[var(--text)]"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="absolute bottom-12 flex gap-6 font-sans text-[11px] tracking-[0.02em] text-[var(--faint)]">
            <a
              href="https://instagram.com/muratgulcelik"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[var(--text)] transition-colors"
            >
              Instagram
            </a>
            <a
              href="https://soundcloud.com/murat-gulcelik"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[var(--text)] transition-colors"
            >
              SoundCloud
            </a>
            <a
              href="https://github.com/mrtglclk"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[var(--text)] transition-colors"
            >
              GitHub
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
